import { $, addAction, INIT } from '@situation/setdesign.util';
import 'waypoints/lib/noframework.waypoints';

/*
    Find animations here: https://daneden.github.io/animate.css/
    The element's class needs to read: <div class="waypoint animated animation__fade">
    The rest will be done by the function.
    Dependent on http://imakewebthings.com/waypoints/ and https://daneden.github.io/animate.css/
 */
/* global Waypoint */
function animatedAsset(animatedClass, animationStyle) {
    const getAnimatedClass = document.getElementsByClassName(animatedClass);

    const handler = function waypointHandler() {
        $(this.element).find('img').addClass(animationStyle);
    };

    for (let i = 0; i < getAnimatedClass.length; i += 1) {
        // eslint-disable-next-line no-new
        new Waypoint({ element: getAnimatedClass[i], handler, offset: '75%' });
    }
}

addAction(INIT, () => {
    animatedAsset('animation__fade--in', 'fade-up');
});
